"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createContents;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _readOnlyError2 = _interopRequireDefault(require("@babel/runtime/helpers/readOnlyError"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _utils = require("./utils");
function createDefaultContentManager() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp;
  function defaultResolve() {
    return _defaultResolve.apply(this, arguments);
  }
  function _defaultResolve() {
    _defaultResolve = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
      var p,
        route,
        wapp,
        req,
        res,
        contentName,
        contents,
        content,
        _args = arguments;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            p = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            route = p.route, wapp = p.wapp, req = p.req, res = p.res;
            contentName = route.contentName;
            contents = contentManager.contents;
            content = contentName && contents[contentName] ? (0, _objectSpread2["default"])({}, contents[contentName]) : null;
            if (!contentManager.firstRequest) {
              _context.next = 8;
              break;
            }
            _context.next = 8;
            return contentManager.firstRequest({
              wapp: wapp,
              req: req,
              res: res
            });
          case 8:
            if (!(content && content.request)) {
              _context.next = 11;
              break;
            }
            _context.next = 11;
            return content.request({
              wapp: wapp,
              req: req,
              res: res
            });
          case 11:
            return _context.abrupt("return", content);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _defaultResolve.apply(this, arguments);
  }
  function getTitle(_ref) {
    var wapp = _ref.wapp,
      res = _ref.res;
    var config = wapp.getTargetObject().config;
    var _config$siteName = config.siteName,
      siteName = _config$siteName === void 0 ? "Wapplr" : _config$siteName;
    var _res$wappResponse = res.wappResponse,
      statusCode = _res$wappResponse.statusCode,
      statusMessage = _res$wappResponse.statusMessage,
      errorMessage = _res$wappResponse.errorMessage;
    var title = "Home";
    if (statusCode === 404) {
      title = statusMessage || "Not found";
    }
    if (statusCode === 500) {
      title = errorMessage || statusMessage || "Internal Server Error";
    }
    return title + " | " + siteName;
  }
  var defaultContentValues = Object.create(Object.prototype, {
    render: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: function render(_ref2) {
        var wapp = _ref2.wapp,
          req = _ref2.req,
          res = _ref2.res;
        return wapp.log.render({
          wapp: wapp,
          req: req,
          res: res
        });
      }
    }),
    title: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: function title(_ref3) {
        var wapp = _ref3.wapp,
          req = _ref3.req,
          res = _ref3.res;
        return getTitle({
          wapp: wapp,
          req: req,
          res: res
        });
      }
    }),
    description: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: function description(_ref4) {
        var wapp = _ref4.wapp,
          req = _ref4.req,
          res = _ref4.res;
        var config = wapp.getTargetObject().config;
        var description = config.description;
        return description ? description : getTitle({
          wapp: wapp,
          req: req,
          res: res
        }).split(" | ")[0];
      }
    }),
    author: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: function author(_ref5) {
        var wapp = _ref5.wapp;
        var config = wapp.getTargetObject().config;
        var author = config.author,
          _config$siteName2 = config.siteName,
          siteName = _config$siteName2 === void 0 ? "Wapplr" : _config$siteName2;
        return author ? author : siteName;
      }
    })
  });
  var defaultContents = Object.create(Object.prototype, {
    log: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultContentValues
    })
  });
  function defaultAdd(obj) {
    if (typeof obj === "object" && !obj.length) {
      Object.keys(obj).forEach(function (contentName) {
        var content = obj[contentName];
        if (typeof content == "object" && content.render) {
          var tempContent = contentManager.contents[contentName] || defaultContentValues;
          contentManager.contents[contentName] = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, tempContent), content);
        }
      });
    }
  }
  function defaultGet(contentName) {
    return contentManager.contents[contentName];
  }
  var defaultComponents = Object.create(Object.prototype, {});
  function defaultAddComponent(obj) {
    if (typeof obj === "object" && !obj.length) {
      Object.keys(obj).forEach(function (componentName) {
        var component = obj[componentName];
        if (typeof component !== "undefined") {
          contentManager.components[componentName] = component;
        }
      });
    }
  }
  function defaultGetComponent(componentName) {
    return contentManager.components[componentName];
  }
  var contentManager = Object.create(Object.prototype, {
    wapp: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      enumerable: false,
      value: wapp
    }),
    resolve: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultResolve
    }),
    contents: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      value: defaultContents
    }),
    components: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      value: defaultComponents
    }),
    add: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultAdd
    }),
    get: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultGet
    }),
    addComponent: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultAddComponent
    }),
    getComponent: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultGetComponent
    }),
    firstRequest: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: null
    })
  });
  return contentManager;
}
function createContents() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp,
    _p$contentManager = p.contentManager,
    contentManager = _p$contentManager === void 0 ? createDefaultContentManager(p) : _p$contentManager;
  function defaultHandle(_x, _x2, _x3) {
    return _defaultHandle.apply(this, arguments);
  }
  function _defaultHandle() {
    _defaultHandle = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(req, res, next) {
      var contentRes;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (res.wappResponse.content) {
              _context2.next = 5;
              break;
            }
            contentRes = contentsMiddleware.contentManager.resolve;
            _context2.next = 4;
            return contentRes({
              route: res.wappResponse.route,
              wapp: wapp,
              req: req,
              res: res
            });
          case 4:
            res.wappResponse.content = _context2.sent;
          case 5:
            return _context2.abrupt("return", next());
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _defaultHandle.apply(this, arguments);
  }
  function defaultAdd(p) {
    return contentsMiddleware.contentManager.add(p);
  }
  function defaultGet(p) {
    return contentsMiddleware.contentManager.get(p);
  }
  function defaultAddComponent(p) {
    return contentsMiddleware.contentManager.addComponent(p);
  }
  function defaultGetComponent(p) {
    return contentsMiddleware.contentManager.getComponent(p);
  }
  var contentsMiddlewareProperties = Object.create(Object.prototype, {
    handle: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultHandle
    }),
    contentManager: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: contentManager
    }),
    add: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultAdd
    }),
    get: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultGet
    }),
    addComponent: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultAddComponent
    }),
    getComponent: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultGetComponent
    })
  });
  function contentsMiddleware(_x4, _x5, _x6) {
    return _contentsMiddleware.apply(this, arguments);
  }
  function _contentsMiddleware() {
    _contentsMiddleware = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(req, res, next) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(typeof contentsMiddleware.handle === "function")) {
              _context3.next = 4;
              break;
            }
            _context3.next = 3;
            return contentsMiddleware.handle(req, res, next);
          case 3:
            return _context3.abrupt("return", _context3.sent);
          case 4:
            return _context3.abrupt("return", contentsMiddleware);
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _contentsMiddleware.apply(this, arguments);
  }
  (0, _utils.mergeProperties)(contentsMiddleware, contentsMiddlewareProperties);
  Object.defineProperty(contentsMiddleware, "wapp", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
    writable: false,
    enumerable: false,
    value: wapp
  }));
  Object.defineProperty(wapp, "contents", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
    writable: false,
    value: contentsMiddleware
  }));
  return contentsMiddleware;
}